module.exports = __webpack_public_path__ + "img/active-bike-example.1d974dc7.png";